import { render, staticRenderFns } from "./SegmentedTrendsButton.vue?vue&type=template&id=3334654e&scoped=true"
import script from "./SegmentedTrendsButton.vue?vue&type=script&lang=ts"
export * from "./SegmentedTrendsButton.vue?vue&type=script&lang=ts"
import style0 from "./SegmentedTrendsButton.vue?vue&type=style&index=0&id=3334654e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3334654e",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/segmented-trends/segmented-trends-button.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fsegmented-trends%2FSegmentedTrendsButton.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports